import React, { Fragment, PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Numeral from "numeral";
import { Button, Row, Col } from "react-bootstrap";

import CajaTexto from "../../../components/UI/cajaTexto/cajaTexto.jsx";
import CajaTextoNumero from "../../../components/UI/cajaTexto/cajaTextoNumero.jsx";
import CajaTextoBusqueda from "../../../components/UI/cajaTexto/cajaTextoBusqueda.jsx";
import Select from "../../../components/UI/Select/Select";
import CheckBox from "../../../components/UI/checkBox/checkBox.jsx";
import RadioButton from '../../../components/UI/RadioButton/RadioButton.jsx';
import ModalBusqueda from "../../../components/UI/modalBusqueda/modalBusquedaFiltro.jsx";
import ColorPicker from "../../../components/UI/colorPicker/colorPicker.jsx";
import { SiteRutas } from "../../../request/RutasConfig";
import { Notificacion } from "../../../components/Util/Notificacion/Notificacion";
import {
    ParametroCallCenter_Detalle,
    ParametroCallCenter_Agregar,
    ParametroCallCenter_Modificar,
    Tipo_Movimiento_Inv_Lista,
    Servicio_Lista,
    Cliente_Lista,
    Cliente_Detalle,
    Repartidores_Lista,
    Pais_Lista,
} from "../../../request/MantenimientosRequest";

class TabParametros extends PureComponent {
    _isMounted = false;

    state = {
        Datos: {
            Emp_id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "none",
                    label: ""
                }
            },
            CC_Id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "unset",
                    label: "ID"
                }
            },
            Monto_x_repartidor: {
                value: "0.00",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Monto por Repartidor:",
                    max: 9999999.99,
                    min: 1,
                    maxLength: 10,
                    decimal: "",
                    Editando: false,
                    step: 0.01
                }
            },
            Orden_x_repartidor: {
                value: "0",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Órdenes por Repartidor:",
                    max: 999,
                    min: 1,
                    maxLength: 3,
                    int: "",
                    Editando: false,
                    step: 1
                }
            },
            ParCodigo_Pais: {
                value: "0",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Código de País:",
                    min: 1,
                    max: 999,
                    Editando: false,
                    step: 1,
                    int: "",
                    maxLength: 3
                }
            },
            ParTiempoEspera: {
                value: "0",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Refrescar Órdenes (Seg):",
                    max: 99999,
                    min: 1,
                    maxLength: 5,
                    Editando: false,
                    step: 1,
                    int: ""
                }
            },
            ParRefrescaMonitoreo: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Refrescar Monitoreo (Seg):",
                    min: 1,
                    max: 99999,
                    Editando: false,
                    step: 1,
                    int: "",
                    maxLength: 5
                }
            },
            ParOrdenesHistoria: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Órdenes para Historia:",
                    min: 1,
                    max: 99999,
                    Editando: false,
                    step: 1,
                    int: "",
                    maxLength: 15
                }
            },
            ParDiasMonitoreo: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Días para Monitoreo:",
                    min: 1,
                    max: 999,
                    Editando: false,
                    step: 1,
                    int: "",
                    maxLength: 3
                }
            },
            ParClienteDefault: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Cliente General:"
                }
            },
            Servicio_Id: {
                value: 0,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Servicio para Flete:"
                }
            },
            Flete_Monto: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Monto para Flete:",
                    min: 0,
                    max: 9999999.99,
                    Editando: false,
                    step: 0.01,
                    decimal: "",
                    maxLength: 10
                }
            },
            Par_Mov_Interbodega: {
                value: 0,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Tipo Movimiento:"
                }
            },
            Par_Forma_Pago: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: ""
                }
            },
            Par_Forma_Pago2: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: ""
                }
            },
            ParBackColor_I: {
                value: "113",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Color Tiempo Inicio",
                    class: "verde",
                    description: "Verde"
                }
            },
            ParBackColor_M: {
                value: "122",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Color Tiempo Medio",
                    class: "amarillo",
                    description: "Amarillo"
                }
            },
            ParBackColor_N: {
                value: "102",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Color Tiempo Nulo",
                    class: "gris",
                    description: "Gris"
                }
            },
            ParBackColor_T: {
                value: "141",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Color Tiempo Terminó",
                    class: "rojo",
                    description: "Rojo"
                }
            },
            ParBackColor_E: {
                value: "143",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Color Modifica Orden",
                    class: "azul",
                    description: "Azul"
                }
            },
            Url_Site_Geolocalizacion: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "URL Site Geolocalización:",
                    maxLength: 500
                }
            },
            Pais_Id: {
                value: 0,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "País Servicio Geolocalización:"
                }
            },
            Email_Alias: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Alias Email Geolocalización:",
                    maxLength: 500
                }
            },
            ParAPI_WhatsApp: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "API WhatsApp:",
                    maxLength: 255
                }
            },
            ParForeColor_I: {
                value: "75",
                attributes: {}
            },
            ParForeColor_M: {
                value: "144",
                attributes: {}
            },
            ParForeColor_T: {
                value: "75",
                attributes: {}
            },
            ParForeColor_N: {
                value: "153",
                attributes: {}
            },
            ParForeColor_E: {
                value: "75",
                attributes: {}
            },
            ParClase_I: {
                value: "verde-claro",
                attributes: {}
            },
            ParClase_M: {
                value: "amarillo",
                attributes: {}
            },
            ParClase_T: {
                value: "rojo",
                attributes: {}
            },
            ParClase_N: {
                value: "gris",
                attributes: {}
            },
            ParClase_E: {
                value: "azul",
                attributes: {}
            },
            ParGoogle_Maps_Key: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "API Key de Mapas de Google:",
                    maxLength: 255
                }
            },
            NombreCliente: {
                value: "",
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "unset",
                    label: "Nombre:"
                }
            },
            Efectivo: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Efectivo",
                    hidden: "none",
                    id: 1
                }
            },
            Tarjeta: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Tarjeta",
                    hidden: "none",
                    id: 2
                }
            },
            Cupones: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Cupones",
                    hidden: "none",
                    id: 3
                }
            },
            Cheque: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Cheque",
                    hidden: "none",
                    id: 4
                }
            },
            MonedaExtranjera: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Extranjera",
                    hidden: "none",
                    id: 5
                }
            },
            Monedero: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Monedero",
                    hidden: "none",
                    id: 7
                }
            },
            GiftCard: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Gift Card",
                    hidden: "none",
                    id: 11
                }
            },
            Transferencia: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Transferencia",
                    hidden: "none",
                    id: 12
                }
            },
            Otra: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Otra",
                    hidden: "none",
                    id: 13
                }
            },
            ParControlRepartidorXSucursal: {
                value: true,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Control de Repartidor por:"
                }
            },
            ControlRepartidorXSucursal: {
                value: true
            },
            ParDiasCalendarizadas: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Días Para Desplegar Órdenes Calendarizadas:",
                    min: 0,
                    max: 30,
                    Editando: false,
                    step: 1,
                    int: "",
                    maxLength: 2
                }
            },
            ParPermiteCalendarizadas: {
                value: false,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Permite Preparar Orden Calendarizada",
                    hidden: "none",
                    id: 'ParPermiteCalendarizadas'
                }
            },
            ValidarArticuloDespacho: {
                value: false,
                attributes: {
                    readOnly: false,
                    focus: false,
                    label: "Validar Códigos de Artículos en Despacho",
                    hidden: "none"
                }
            },
            ParNotificacion_Hub_Ruta: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Notificación Hub Ruta:",
                    maxLength: 50
                }
            },
            ParNotificacion_Hub_Conexion: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Notificación Hub Conexión:",
                    maxLength: 250
                }
            }
        },
        lstColores: [{
            color: "gris",
            descripcion: "Gris",
            hexa: "#A9ADC1",
            valorColor: "102",
            fore: "153"
        }, {
            color: "azul",
            descripcion: "Azul",
            hexa: "#4C7EF8",
            valorColor: "143",
            fore: "75"
        }, {
            color: "verde",
            descripcion: "Verde",
            hexa: "#00D084",
            valorColor: "113",
            fore: "75"
        }, {
            color: "amarillo",
            descripcion: "Amarillo",
            hexa: "#FCD393",
            valorColor: "122",
            fore: "144"
        }, {
            color: "naranja",
            descripcion: "Naranja",
            hexa: "#FF6900",
            valorColor: "44",
            fore: "75"
        }, {
            color: "celeste",
            descripcion: "Celeste",
            hexa: "#8ED1FC",
            valorColor: "100",
            fore: "153"
        }, {
            color: "rojo",
            descripcion: "Rojo",
            hexa: "#EB1414",
            valorColor: "141",
            fore: "75"
        }, {
            color: "verde-claro",
            descripcion: "Verde Claro",
            hexa: "#7BDCB5",
            valorColor: "109",
            fore: "153"
        }, {
            color: "azul-oscuro",
            descripcion: "Azul Oscuro",
            hexa: "#070E52",
            valorColor: "118",
            fore: "75"
        }, {
            color: "verde-oscuro",
            descripcion: "Verde Oscuro",
            hexa: "#006064",
            valorColor: "158",
            fore: "75"
        }],
        lstTiposMovimientos: [{ Tipo_Id: 0, Nombre: "Seleccione" }],
        lstServicios: [{ Id: 0, Nombre: "Seleccione" }],
        lstPaises: [{ Id: 0, Nombre: "Seleccione" }],
        ParametrosCallCenter: null,
        Id: 0,
        selectModal: false,
        lstClientes: [],
        selected: null,
        menuId: 0
    }

    componentDidMount() {
        this._isMounted = true;

        let menuId = 0;
        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }
        this.setState({ menuId });

        this.obtenerParametrosCallCenter();
        this.cargarServiciosFlete();
        this.cargarTiposMovimiento();
        this.cargarPaises();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.CadenaId !== prevProps.CadenaId) {
            let Datos = { ...this.state.Datos };
            this.obtenerClienteNombre(Datos.ParClienteDefault.value);
        }
    }

    obtenerParametrosCallCenter = async () => {
        const callcenter_id = this.props.Id;
        if (callcenter_id > 0) {
            try {
                const ParametrosCallCenter = await ParametroCallCenter_Detalle(this.props.token, this.props.empresa.Id, callcenter_id);
                this.cargarParametrosCallCenter(ParametrosCallCenter, this.props.empresa.Id, callcenter_id);
            } catch (error) {
                Notificacion.error(error);
            }
        }
    }

    obtenerClienteNombre = async (pCliente_Id) => {
        if (this.props.CadenaId && pCliente_Id) {
            const cliente = await Cliente_Detalle(this.props.token, this.props.empresa.Id, this.props.CadenaId, pCliente_Id);

            let Datos = { ...this.state.Datos };
            Datos.NombreCliente.value = cliente.Nombre;
            this._isMounted && this.setState({ Datos });
            !cliente.Nombre && Notificacion.error("Cliente no existe");
        }
    }

    cargarServiciosFlete = async () => {
        const respuesta = await Servicio_Lista(this.props.token, this.props.empresa.Id);
        if (respuesta.Exitoso) {
            this._isMounted && this.setState({ lstServicios: [{ Id: 0, Nombre: "Seleccione" }, ...respuesta.Datos] });
        } else {
            Notificacion.error(respuesta.Mensaje);
        }
    }

    cargarTiposMovimiento = async () => {
        const respuesta = await Tipo_Movimiento_Inv_Lista(this.props.token, this.props.empresa.Id);
        if (respuesta.Exitoso) {
            this._isMounted && this.setState({ lstTiposMovimientos: [{ Tipo_Id: 0, Nombre: "Seleccione" }, ...respuesta.Datos] });
        } else {
            Notificacion.error(respuesta.Mensaje);
        }
    }

    cargarPaises = async () => {
        const respuesta = await Pais_Lista(this.props.token);
        if (respuesta.Exitoso) {
            this._isMounted && this.setState({ lstPaises: [{ Id: 0, Nombre: "Seleccione" }, ...respuesta.Datos] });
        } else {
            Notificacion.error(respuesta.Mensaje);
        }
    }

    cargarParametrosCallCenter = (ParametrosCallCenter, empresa, Id) => {
        const lstColores = this.state.lstColores;
        let Datos = { ...this.state.Datos };
        Datos.Emp_id.value = empresa;
        Datos.CC_Id.value = Id;

        if (ParametrosCallCenter) {
            Datos.Monto_x_repartidor.value = ParametrosCallCenter.Monto_x_repartidor;
            Datos.Orden_x_repartidor.value = ParametrosCallCenter.Orden_x_repartidor;
            Datos.ParTiempoEspera.value = ParametrosCallCenter.ParTiempoEspera;
            Datos.ParRefrescaMonitoreo.value = ParametrosCallCenter.ParRefrescaMonitoreo;
            Datos.ParDiasMonitoreo.value = ParametrosCallCenter.ParDiasMonitoreo;
            Datos.ParOrdenesHistoria.value = ParametrosCallCenter.ParOrdenesHistoria;
            Datos.ParClienteDefault.value = ParametrosCallCenter.ParClienteDefault;
            Datos.ParBackColor_I.value = ParametrosCallCenter.ParBackColor_I;
            Datos.ParBackColor_M.value = ParametrosCallCenter.ParBackColor_M;
            Datos.ParBackColor_N.value = ParametrosCallCenter.ParBackColor_N;
            Datos.ParBackColor_T.value = ParametrosCallCenter.ParBackColor_T;
            Datos.ParBackColor_E.value = ParametrosCallCenter.ParBackColor_E;
            Datos.ParForeColor_I.value = ParametrosCallCenter.ParForeColor_I;
            Datos.ParForeColor_M.value = ParametrosCallCenter.ParForeColor_M;
            Datos.ParForeColor_N.value = ParametrosCallCenter.ParForeColor_N;
            Datos.ParForeColor_T.value = ParametrosCallCenter.ParForeColor_T;
            Datos.ParForeColor_E.value = ParametrosCallCenter.ParForeColor_E;
            Datos.ParClase_I.value = ParametrosCallCenter.ParClase_I;
            Datos.ParClase_M.value = ParametrosCallCenter.ParClase_M;
            Datos.ParClase_N.value = ParametrosCallCenter.ParClase_N;
            Datos.ParClase_T.value = ParametrosCallCenter.ParClase_T;
            Datos.ParClase_E.value = ParametrosCallCenter.ParClase_E;
            Datos.Par_Mov_Interbodega.value = ParametrosCallCenter.Par_Mov_Interbodega;
            Datos.Servicio_Id.value = ParametrosCallCenter.Servicio_Id;
            Datos.Pais_Id.value = ParametrosCallCenter.Pais_Id;
            Datos.Flete_Monto.value = ParametrosCallCenter.Flete_Monto;
            Datos.Par_Forma_Pago.value = ParametrosCallCenter.Par_Forma_Pago;
            Datos.Par_Forma_Pago2.value = ParametrosCallCenter.Par_Forma_Pago2;
            Datos.ParGoogle_Maps_Key.value = ParametrosCallCenter.ParGoogle_Maps_Key;
            Datos.Url_Site_Geolocalizacion.value = ParametrosCallCenter.Url_Site_Geolocalizacion;
            Datos.Email_Alias.value = ParametrosCallCenter.Email_Alias;
            Datos.ParAPI_WhatsApp.value = ParametrosCallCenter.ParAPI_WhatsApp;
            Datos.ParCodigo_Pais.value = ParametrosCallCenter.ParCodigo_Pais;
            Datos.ParDiasCalendarizadas.value = ParametrosCallCenter.ParDiasCalendarizadas;
            Datos.ParPermiteCalendarizadas.value = ParametrosCallCenter.ParPermiteCalendarizadas;
            Datos.ValidarArticuloDespacho.value = ParametrosCallCenter.ValidarArticuloDespacho;
            Datos.ParNotificacion_Hub_Ruta.value = ParametrosCallCenter.ParNotificacion_Hub_Ruta;
            Datos.ParNotificacion_Hub_Conexion.value = ParametrosCallCenter.ParNotificacion_Hub_Conexion;

            Datos.Efectivo.value = false;
            Datos.Tarjeta.value = false;
            Datos.Cupones.value = false;
            Datos.Cheque.value = false;
            Datos.MonedaExtranjera.value = false;
            Datos.Monedero.value = false;
            Datos.GiftCard.value = false;
            Datos.Transferencia.value = false;
            Datos.Otra.value = false;

            Datos.ParControlRepartidorXSucursal.value = ParametrosCallCenter.ParControlRepartidorXSucursal;
            Datos.ControlRepartidorXSucursal.value = ParametrosCallCenter.ParControlRepartidorXSucursal;

            var fpago = ParametrosCallCenter.Par_Forma_Pago2.split("|");

            for (var i = 0; i < fpago.length; i++) {
                let val = parseInt(fpago[i]);

                switch (val) {
                    case Datos.Efectivo.attributes.id:
                        Datos.Efectivo.value = true;
                        break;
                    case Datos.Tarjeta.attributes.id:
                        Datos.Tarjeta.value = true;
                        break;
                    case Datos.Cupones.attributes.id:
                        Datos.Cupones.value = true;
                        break;
                    case Datos.Cheque.attributes.id:
                        Datos.Cheque.value = true;
                        break;
                    case Datos.MonedaExtranjera.attributes.id:
                        Datos.MonedaExtranjera.value = true;
                        break;
                    case Datos.Monedero.attributes.id:
                        Datos.Monedero.value = true;
                        break;
                    case Datos.GiftCard.attributes.id:
                        Datos.GiftCard.value = true;
                        break;
                    case Datos.Transferencia.attributes.id:
                        Datos.Transferencia.value = true;
                        break;
                    case Datos.Otra.attributes.id:
                        Datos.Otra.value = true;
                        break;
                    default:
                        break;
                }
            }

            /* seteando valores de color */

            let valorColor = Datos.ParBackColor_I.value;
            let resultado = lstColores.filter(item => item.valorColor.trim().toUpperCase() == valorColor.trim().toUpperCase());
            if (resultado.length > 0) {
                Datos.ParBackColor_I.attributes.class = resultado[0].color;
                Datos.ParBackColor_I.attributes.description = resultado[0].descripcion;
            }

            valorColor = Datos.ParBackColor_M.value;
            resultado = lstColores.filter(item => item.valorColor == valorColor);
            if (resultado.length > 0) {
                Datos.ParBackColor_M.attributes.class = resultado[0].color;
                Datos.ParBackColor_M.attributes.description = resultado[0].descripcion;
            }

            valorColor = Datos.ParBackColor_T.value;
            resultado = lstColores.filter(item => item.valorColor == valorColor);
            if (resultado.length > 0) {
                Datos.ParBackColor_T.attributes.class = resultado[0].color;
                Datos.ParBackColor_T.attributes.description = resultado[0].descripcion;
            }

            valorColor = Datos.ParBackColor_N.value;
            resultado = lstColores.filter(item => item.valorColor == valorColor);
            if (resultado.length > 0) {
                Datos.ParBackColor_N.attributes.class = resultado[0].color;
                Datos.ParBackColor_N.attributes.description = resultado[0].descripcion;
            }

            valorColor = Datos.ParBackColor_E.value;
            resultado = lstColores.filter(item => item.valorColor == valorColor);
            if (resultado.length > 0) {
                Datos.ParBackColor_E.attributes.class = resultado[0].color;
                Datos.ParBackColor_E.attributes.description = resultado[0].descripcion;
            }
        }

        this._isMounted && this.setState({ Datos, ParametrosCallCenter }, () => {
            this.obtenerClienteNombre(Datos.ParClienteDefault.value);
        });
    };

    obtenerClientes = async (pFiltro) => {
        if (this.props.CadenaId) {
            const respuesta = await Cliente_Lista(this.props.token, this.props.empresa.Id, this.props.CadenaId, pFiltro);
            if (respuesta.Exitoso) {
                this._isMounted && this.setState({ lstClientes: respuesta.Datos });
                if (respuesta.Datos.length === 0) {
                    Notificacion.error("No se encontraron clientes con el parámetro ingresado.");
                }
                return;
            }
            else {
                Notificacion.error(respuesta.Mensaje);
            }
        }
        this._isMounted && this.setState({ lstClientes: [] });
    }

    validarDatos = () => {
        const _datos = this.state.Datos;

        if (_datos.Monto_x_repartidor.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Monto por Repartidor");
            return false;
        }

        if (
            _datos.Monto_x_repartidor.value <= 0 ||
            _datos.Monto_x_repartidor.value > 9999999.99
        ) {
            Notificacion.error("Error: Debe ingresar Monto por Repartidor válido, entre 1 y 9,999,999.99");
            return false;
        }

        if (_datos.Orden_x_repartidor.value.toString().trim().length == 0) {
            Notificacion.error(
                "Error: Debe ingresar el dato: Órdenes por Repartidor"
            );
            return false;
        }

        if (
            _datos.Orden_x_repartidor.value <= 0 ||
            _datos.Orden_x_repartidor.value > 999
        ) {
            Notificacion.error(
                "Error: Debe ingresar un dato válido: Órdenes por Repartidor entre 1 y 999"
            );
            return false;
        }

        if (_datos.ParTiempoEspera.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Refrescar Órdenes");
            return false;
        }

        if (
            _datos.ParTiempoEspera.value <= 0 ||
            _datos.ParTiempoEspera.value > 99999
        ) {
            Notificacion.error(
                "Error: Debe ingresar un dato válido: Refrescar Órdenes entre 1 y 99,999"
            );
            return false;
        }

        if (_datos.ParOrdenesHistoria.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Órdenes para Historia");
            return false;
        }

        if (_datos.ParOrdenesHistoria.value <= 0 || _datos.ParOrdenesHistoria.value > 99999) {
            Notificacion.error("Error: Debe ingresar el dato: Órdenes para Historia entre 1 y 99,999");
            return false;
        }

        if (_datos.ParRefrescaMonitoreo.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Refrescar Monitoreo");
            return false;
        }

        if (_datos.ParRefrescaMonitoreo.value <= 0 || _datos.ParRefrescaMonitoreo.value > 99999) {
            Notificacion.error("Error: Debe ingresar un dato válido: Refrescar Monitoreo entre 1 y 99,999");
            return false;
        }

        if (_datos.ParDiasMonitoreo.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Días para Monitoreo");
            return false;
        }

        if (_datos.ParDiasMonitoreo.value <= 0 || _datos.ParDiasMonitoreo.value > 999) {
            Notificacion.error("Error: Debe ingresar un dato válido: Días para Monitoreo entre 1 y 999");
            return false;
        }

        if (_datos.ParClienteDefault.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Cliente General");
            return false;
        }

        if (_datos.ParClienteDefault.value <= 0) {
            Notificacion.error("Error: Debe ingresar el dato: Cliente General");
            return false;
        }

        if (_datos.Servicio_Id.value == 0) {
            Notificacion.error("Error: Debe seleccionar el dato: Servicio para Flete");
            return false;
        }

        if (_datos.Pais_Id.value == 0) {
            Notificacion.error("Error: Debe seleccionar el dato: Pais Servicio Geolocalización");
            return false;
        }

        if (_datos.Flete_Monto.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Monto para Flete");
            return false;
        }

        if (_datos.Flete_Monto.value < 0 || _datos.Flete_Monto.value > 9999999.99) {
            Notificacion.error("Error: Debe ingresar el dato: Monto para Flete entre 0 y 9,999,999.99");
            return false;
        }

        if (_datos.ParGoogle_Maps_Key.value.length == 0 || _datos.ParGoogle_Maps_Key.value.length > 255) {
            Notificacion.error("Error: Debe ingresar el dato: API Key de Mapas de Google, con longitud entre 1 y 255");
            return false;
        }

        if (_datos.Url_Site_Geolocalizacion.value.length > 500) {
            Notificacion.error("Error: Debe ingresar el dato: Url Site Geolocalización, con longitud menor o igual a 500");
            return false;
        }

        if (_datos.Email_Alias.value.length > 100) {
            Notificacion.error("Error: Debe ingresar el dato: Alias Email Geolocalización, con longitud menor o igual a 100");
            return false;
        }

        if (_datos.ParAPI_WhatsApp.value.length > 255) {
            Notificacion.error("Error: Debe ingresar el dato: API WhatsApp, con longitud menor o igual a 255");
            return false;
        }

        if (_datos.ParCodigo_Pais.value < 0 || _datos.ParCodigo_Pais.value > 999) {
            Notificacion.error("Error: Debe ingresar el dato: Código País entre 0 y 999");
            return false;
        }

        if (_datos.Par_Mov_Interbodega.value == 0) {
            Notificacion.error("Error: Debe selecionar el dato: Tipo Movimiento");
            return false;
        }


        if (_datos.ParDiasCalendarizadas.value.toString().trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Días Para Desplegar Órdenes Calendarizadas");
            return false;
        }

        if (_datos.ParDiasCalendarizadas.value < 0 || _datos.ParDiasCalendarizadas.value > 30) {
            Notificacion.error("Error: Debe ingresar un dato válido: Días Para Desplegar Órdenes Calendarizadas entre 0 y 30");
            return false;
        }

        if (_datos.ParNotificacion_Hub_Ruta.value.length > 50) {
            Notificacion.error("Error: Debe ingresar el dato: Notificación Hub Ruta, con longitud menor o igual a 50.");
            return false;
        }

        if (_datos.ParNotificacion_Hub_Conexion.value.length > 250) {
            Notificacion.error("Error: Debe ingresar el dato: Notificación Hub Conexión, con longitud menor o igual a 250.");
            return false;
        }

        return true;
    };

    ingresarDatos = async () => {
        if (this.validarDatos()) {
            const _id = this.props.Id;
            const token = this.props.token;
            const empresa = this.props.empresa.Id;
            const ParametrosCallCenter = this.state.ParametrosCallCenter;

            let Datos = { ...this.state.Datos };
            Datos.CC_Id.value = _id;
            Datos.Emp_id.value = empresa;

            let FormaPago = "";
            let FormaPago2 = "";

            if (Datos.Efectivo.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Efectivo.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Efectivo.attributes.id.toString();

                FormaPago = FormaPago + Datos.Efectivo.attributes.id.toString();

            }

            if (Datos.Tarjeta.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Tarjeta.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Tarjeta.attributes.id.toString();

                FormaPago = FormaPago + Datos.Tarjeta.attributes.id.toString();
            }

            if (Datos.Cupones.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Cupones.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Cupones.attributes.id.toString();
                FormaPago = FormaPago + Datos.Cupones.attributes.id.toString();
            }

            if (Datos.Cheque.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Cheque.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Cheque.attributes.id.toString();
                FormaPago = FormaPago + Datos.Cheque.attributes.id.toString();
            }

            if (Datos.MonedaExtranjera.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.MonedaExtranjera.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.MonedaExtranjera.attributes.id.toString();
                FormaPago = FormaPago + Datos.MonedaExtranjera.attributes.id.toString();
            }

            if (Datos.Monedero.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Monedero.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Monedero.attributes.id.toString();
                FormaPago = FormaPago + Datos.Monedero.attributes.id.toString();
            }

            if (Datos.GiftCard.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.GiftCard.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.GiftCard.attributes.id.toString();
            }

            if (Datos.Transferencia.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Transferencia.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Transferencia.attributes.id.toString();
            }

            if (Datos.Otra.value == true) {
                if (FormaPago2 === "")
                    FormaPago2 = FormaPago2 + Datos.Otra.attributes.id.toString();
                else
                    FormaPago2 = FormaPago2 + "|" + Datos.Otra.attributes.id.toString();
            }
            Datos.Par_Forma_Pago.value = FormaPago;
            Datos.Par_Forma_Pago2.value = FormaPago2;

            const parametros = {
                Emp_id: Datos.Emp_id.value,
                CC_Id: Datos.CC_Id.value,
                Monto_x_repartidor: Datos.Monto_x_repartidor.value,
                Orden_x_repartidor: Datos.Orden_x_repartidor.value,
                ParTiempoEspera: Datos.ParTiempoEspera.value,
                ParRefrescaMonitoreo: Datos.ParRefrescaMonitoreo.value,
                ParOrdenesHistoria: Datos.ParOrdenesHistoria.value,
                ParDiasMonitoreo: Datos.ParDiasMonitoreo.value,
                ParClienteDefault: Datos.ParClienteDefault.value,
                ParBackColor_I: Datos.ParBackColor_I.value,
                ParBackColor_M: Datos.ParBackColor_M.value,
                ParBackColor_N: Datos.ParBackColor_N.value,
                ParBackColor_T: Datos.ParBackColor_T.value,
                ParBackColor_E: Datos.ParBackColor_E.value,
                ParForeColor_I: Datos.ParForeColor_I.value,
                ParForeColor_M: Datos.ParForeColor_M.value,
                ParForeColor_N: Datos.ParForeColor_N.value,
                ParForeColor_T: Datos.ParForeColor_T.value,
                ParForeColor_E: Datos.ParForeColor_E.value,
                Par_Mov_Interbodega: Datos.Par_Mov_Interbodega.value,
                Servicio_Id: Datos.Servicio_Id.value,
                Pais_Id: Datos.Pais_Id.value,
                Flete_Monto: Datos.Flete_Monto.value,
                Par_Forma_Pago: Datos.Par_Forma_Pago.value,
                Par_Forma_Pago2: Datos.Par_Forma_Pago2.value,
                ParClase_I: Datos.ParClase_I.value,
                ParClase_M: Datos.ParClase_M.value,
                ParClase_T: Datos.ParClase_T.value,
                ParClase_N: Datos.ParClase_N.value,
                ParClase_E: Datos.ParClase_E.value,
                ParGoogle_Maps_Key: Datos.ParGoogle_Maps_Key.value,
                Url_Site_Geolocalizacion: Datos.Url_Site_Geolocalizacion.value,
                Email_Alias: Datos.Email_Alias.value,
                ParAPI_WhatsApp: Datos.ParAPI_WhatsApp.value,
                ParCodigo_Pais: Datos.ParCodigo_Pais.value,
                ParControlRepartidorXSucursal: Datos.ParControlRepartidorXSucursal.value,
                ParDiasCalendarizadas: Datos.ParDiasCalendarizadas.value,
                ParPermiteCalendarizadas: Datos.ParPermiteCalendarizadas.value,
                ValidarArticuloDespacho: Datos.ValidarArticuloDespacho.value,
                ParNotificacion_Hub_Ruta: Datos.ParNotificacion_Hub_Ruta.value,
                ParNotificacion_Hub_Conexion: Datos.ParNotificacion_Hub_Conexion.value
            };

            let resultado = "";
            if (ParametrosCallCenter != null) {

                if (Datos.ParControlRepartidorXSucursal.value === Datos.ControlRepartidorXSucursal.value) {
                    resultado = await ParametroCallCenter_Modificar(token, parametros);
                } else {

                    const response = await Repartidores_Lista(token, Datos.Emp_id.value, Datos.CC_Id.value);
                    let listaRepartidores = [];

                    if (response.Exitoso) {

                        listaRepartidores = response.Datos;

                    } else {

                        Notificacion.error(response.Mensaje);

                    }

                    let existe = listaRepartidores.filter(rep => rep.Estatus === "R");

                    if (response.Exitoso && existe.length > 0) {

                        Notificacion.warning('No se puede variar el parámetro Control de Repartidor porque existen registros de Repartidores en Ruta.');

                    } else if (response.Exitoso) {

                        resultado = await ParametroCallCenter_Modificar(token, parametros);

                    }

                }

            } else {
                resultado = await ParametroCallCenter_Agregar(token, parametros);
            }

            if (resultado !== "") {
                if (resultado.CodigoError == 0) {
                    if (_id > 0) {
                        Notificacion.success("Se actualizó la información con éxito ");
                    } else {
                        Notificacion.success("Se almacenó la información con éxito");
                    }
                } else {
                    Notificacion.error("Error: " + resultado.Mensaje);
                }
            }
        }
    };

    volverAtras = () => {
        const menuId = this.state.menuId;
        this.props.history.push({
            pathname: `${SiteRutas.CallCenter}`,
            state: { menuId: menuId },
        });
    }

    onSelectChanged = (event) => {
        const { name, value, options, selectedIndex } = event.target;

        let newAttributes = this.state.Datos[name].attributes;
        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });
        if (this._isMounted) {
            this.setState({ Datos });
        }
    };

    validarDecimal = (pValor) => {
        let isValid = true;
        if (pValor.toString().length > 0) {
            let strporc = pValor;
            isValid =
                strporc.match(/^((999999999(\.0{1,2})?)|(\d{1,9}(\.\d{0,4})?))$/) ==
                    null
                    ? false
                    : true;
        }
        return isValid;
    };

    validarInt = (pValor) => {
        let isValid = true;
        if (pValor.toString().length > 0) {
            let strporc = pValor;
            isValid =
                strporc.match(/^((999999(\.0{1,2})?)|(\d{1,6}?))$/) == null
                    ? false
                    : true;
        }
        return isValid;
    };

    formatearMontos = (valor, formato) => {
        return Numeral(valor).format(formato);
    };

    onChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        let newAttributes = this.state.Datos[name].attributes;

        const decimal = newAttributes.decimal != undefined ? true : false;
        const int = newAttributes.int != undefined ? true : false;
        let valido = true;

        if (decimal) {
            valido = this.validarDecimal(value);
        } else if (int) {
            valido = this.validarInt(value);
        }

        if (valido) {
            const Datos = Object.assign({}, this.state.Datos, {
                [name]: { value: value, attributes: newAttributes },
            });
            if (this._isMounted) {
                this.setState({ Datos });
            }
        }
    };

    onChangeEditar = (e) => {
        const name = e.target.name;
        const value = this.state.Datos[name].value;
        let newAttributes = this.state.Datos[name].attributes;
        const _Editando = !newAttributes.Editando;
        newAttributes.Editando = _Editando;
        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });
        if (_Editando) {
            e.target.type = "text";
            e.target.value = value.toString().replace(",", "");
            e.target.setSelectionRange(0, e.target.value.toString().length);
            e.target.type = "number";
        }
        if (this._isMounted) {
            this.setState({ Datos });
        }
    };

    onFormato = (valor) => {
        let _formato = "0,0.00";
        return this.formatearMontos(valor, _formato);
    };

    onFormatoInt = (valor) => {
        let _formato = "0,0";
        return this.formatearMontos(valor, _formato);
    };

    handleCheckBox = (event) => {
        const name = event.target.name;
        const value = event.target.checked;
        let newAttributes = this.state.Datos[name].attributes;

        let Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });
        if (this._isMounted) {
            this.setState({ Datos });
        }
    };

    handleControlRepartidor = event => {
        const { value, name } = event.target;

        let newAttributes = this.state.Datos[name].attributes;

        let Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value === "1", attributes: newAttributes },
        });

        this.setState({ Datos });
    }

    onChangeInputCli = (e) => {
        const { value, name } = e.target;

        let newAttributes = this.state.Datos[name].attributes;
        let Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });

        Datos.NombreCliente.value = "";
        this.setState({ Datos });
    };

    onKeyPressCli = (e) => {
        const { value } = e.target;

        const cliente_id = value.toString().trim();

        if (e.charCode == 13 && cliente_id.length > 0) {
            this.obtenerClienteNombre(cliente_id);
        }
    };

    onBlurCli = (e) => {
        const { Datos } = this.state;

        if (Datos.ParClienteDefault.value.toString().trim().length > 0) {
            this.obtenerClienteNombre(Datos.ParClienteDefault.value);
        }
    };

    handleModalCli = () => {
        this.setState({ selectModal: true });
    };

    onRowSelect = (row, isSelect) => {
        this.setState({ selected: isSelect ? row : undefined });
    };

    onDoubleClick = (e, row, rowIndex) => {
        let Datos = { ...this.state.Datos };
        Datos.NombreCliente.value = row.Nombre;
        Datos.ParClienteDefault.value = row.Cliente_Id;

        this.setState({ selected: null, selectModal: false, lstClientes: [], Datos });
    }

    onClickSearch = (pFiltro) => {
        if (pFiltro && pFiltro.trim()) {
            this.obtenerClientes(pFiltro);
        } else {
            Notificacion.error("Debe ingresar un filtro de búsqueda para Clientes");
        }
    }

    cerrarModal = () => {
        this.setState({ selectModal: false, selected: null, lstClientes: [] });
    };

    seleccionModal = () => {
        const { selected } = this.state;
        if (selected) {
            let Datos = { ...this.state.Datos };
            Datos.NombreCliente.value = selected.Nombre;
            Datos.ParClienteDefault.value = selected.Cliente_Id;

            this.setState({ Datos, selected: null, selectModal: false });
        } else {
            Notificacion.error("Debe seleccionar un Cliente");
        }
    };

    handleChangeColor_I = (color, event) => {
        const lstColores = this.state.lstColores;
        const resultado = lstColores.filter(item => item.hexa.toUpperCase() === color.hex.toUpperCase());
        if (resultado.length > 0) {
            let Datos = { ...this.state.Datos };
            Datos.ParBackColor_I.attributes.class = resultado[0].color;
            Datos.ParBackColor_I.attributes.description = resultado[0].descripcion;
            Datos.ParBackColor_I.value = resultado[0].valorColor;
            Datos.ParForeColor_I.value = resultado[0].fore;
            Datos.ParClase_I.value = resultado[0].color;

            this._isMounted && this.setState({ Datos });
        }
    };

    handleChangeColor_M = (color) => {
        const resultado = this.state.lstColores.filter(item => item.hexa.toUpperCase() == color.hex.toUpperCase());
        if (resultado.length > 0) {
            let Datos = { ...this.state.Datos };
            Datos.ParBackColor_M.attributes.class = resultado[0].color;
            Datos.ParBackColor_M.attributes.description = resultado[0].descripcion;
            Datos.ParBackColor_M.value = resultado[0].valorColor;
            Datos.ParForeColor_M.value = resultado[0].fore;
            Datos.ParClase_M.value = resultado[0].color;

            this._isMounted && this.setState({ Datos });
        }
    };
    handleChangeColor_T = (color, event) => {
        const lstColores = this.state.lstColores;
        const hex = color.hex;
        let Datos = { ...this.state.Datos };

        const resultado = lstColores.filter(
            (item) => item.hexa.toUpperCase() == hex.toUpperCase()
        );

        if (resultado.length > 0) {
            Datos.ParBackColor_T.attributes.class = resultado[0].color;
            Datos.ParBackColor_T.attributes.description = resultado[0].descripcion;
            Datos.ParBackColor_T.value = resultado[0].valorColor;
            Datos.ParForeColor_T.value = resultado[0].fore;
            Datos.ParClase_T.value = resultado[0].color;

            if (this._isMounted) {
                this.setState({ Datos });
            }
        }
    };
    handleChangeColor_N = (color, event) => {
        const lstColores = this.state.lstColores;
        const hex = color.hex;
        let Datos = { ...this.state.Datos };

        const resultado = lstColores.filter(
            (item) => item.hexa.toUpperCase() == hex.toUpperCase()
        );

        if (resultado.length > 0) {
            Datos.ParBackColor_N.attributes.class = resultado[0].color;
            Datos.ParBackColor_N.attributes.description = resultado[0].descripcion;
            Datos.ParBackColor_N.value = resultado[0].valorColor;
            Datos.ParForeColor_N.value = resultado[0].fore;
            Datos.ParClase_N.value = resultado[0].color;

            if (this._isMounted) {
                this.setState({ Datos });
            }
        }
    };
    handleChangeColor_E = (color, event) => {
        const lstColores = this.state.lstColores;
        const hex = color.hex;
        let Datos = { ...this.state.Datos };

        const resultado = lstColores.filter(
            (item) => item.hexa.toUpperCase() == hex.toUpperCase()
        );

        if (resultado.length > 0) {
            Datos.ParBackColor_E.attributes.class = resultado[0].color;
            Datos.ParBackColor_E.attributes.description = resultado[0].descripcion;
            Datos.ParBackColor_E.value = resultado[0].valorColor;
            Datos.ParForeColor_E.value = resultado[0].fore;
            Datos.ParClase_E.value = resultado[0].color;

            if (this._isMounted) {
                this.setState({ Datos });
            }
        }
    };

    render() {
        const { lstServicios, lstTiposMovimientos, Datos, selectModal, lstClientes, lstPaises } = this.state;

        const lstColoresHexa = ["#A9ADC1", "#4C7EF8", "#00D084", "#FCD393", "#FF6900", "#8ED1FC", "#EB1414", "#7BDCB5", "#070E52", "#006064"];
        const columnasClientes = [
            { dataField: "Cliente_Id", text: "Id", sort: true },
            { dataField: "Nombre", text: "Nombre", sort: true }
        ];

        const selectRow = {
            mode: "radio",
            clickToSelect: true,
            hideSelectColumn: true,
            onSelect: this.onRowSelect,
            style: { background: "#e2f3f9" },
            blurToSave: true,
            autoSelectText: true
        };

        return (
            <Fragment>
                <Row>
                    <Col xs={6}>
                        <h6>Parámetros</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTextoNumero
                            id="Monto_x_repartidor"
                            type="number"
                            label={Datos.Monto_x_repartidor.attributes.label}
                            value={Datos.Monto_x_repartidor.value}
                            attributes={Datos.Monto_x_repartidor.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormato}
                        />
                    </Col>
                    <Col>
                        <CajaTextoNumero
                            id="Orden_x_repartidor"
                            type="number"
                            label={Datos.Orden_x_repartidor.attributes.label}
                            value={Datos.Orden_x_repartidor.value}
                            attributes={Datos.Orden_x_repartidor.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTextoNumero
                            id="ParTiempoEspera"
                            type="number"
                            label={Datos.ParTiempoEspera.attributes.label}
                            value={Datos.ParTiempoEspera.value}
                            attributes={Datos.ParTiempoEspera.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                    <Col>
                        <CajaTextoNumero
                            id="ParOrdenesHistoria"
                            type="number"
                            label={Datos.ParOrdenesHistoria.attributes.label}
                            value={Datos.ParOrdenesHistoria.value}
                            attributes={Datos.ParOrdenesHistoria.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTextoNumero
                            id="ParRefrescaMonitoreo"
                            type="number"
                            label={Datos.ParRefrescaMonitoreo.attributes.label}
                            value={Datos.ParRefrescaMonitoreo.value}
                            attributes={Datos.ParRefrescaMonitoreo.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                    <Col>
                        <CajaTextoNumero
                            id="ParDiasMonitoreo"
                            type="number"
                            label={Datos.ParDiasMonitoreo.attributes.label}
                            value={Datos.ParDiasMonitoreo.value}
                            attributes={Datos.ParDiasMonitoreo.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTextoBusqueda
                            id="ParClienteDefault"
                            type="text"
                            label={Datos.ParClienteDefault.attributes.label}
                            value={Datos.ParClienteDefault.value}
                            attributes={Datos.ParClienteDefault.attributes}
                            onChangeInput={this.onChangeInputCli}
                            onClick={this.handleModalCli}
                            onKeyPress={this.onKeyPressCli}
                            onBlur={this.onBlurCli}
                        />
                    </Col>
                    <Col>
                        <CajaTexto
                            id="NombreCliente"
                            type="text"
                            label={Datos.NombreCliente.attributes.label}
                            value={Datos.NombreCliente.value}
                            attributes={Datos.NombreCliente.attributes}
                            onChangeInput={() => { }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Select
                            id="Servicio_Id"
                            name="Servicio_Id"
                            labelText={Datos.Servicio_Id.attributes.label}
                            classNameContainer="form-group"
                            className="form-control"
                            value={Datos.Servicio_Id.value}
                            onChange={this.onSelectChanged}
                            configuration={{
                                valueField: "Id",
                                textField: "Nombre",
                                options: lstServicios,
                            }}
                        />
                    </Col>
                    <Col>
                        <CajaTextoNumero
                            id="Flete_Monto"
                            type="number"
                            label={Datos.Flete_Monto.attributes.label}
                            value={Datos.Flete_Monto.value}
                            attributes={Datos.Flete_Monto.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormato}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="6">
                        <CajaTexto
                            id="ParGoogle_Maps_Key"
                            type="text"
                            label={Datos.ParGoogle_Maps_Key.attributes.label}
                            value={Datos.ParGoogle_Maps_Key.value}
                            attributes={Datos.ParGoogle_Maps_Key.attributes}
                            onChangeInput={this.onChangeInput}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <label>{Datos.ParControlRepartidorXSucursal.attributes.label}</label>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs="auto">
                        <RadioButton id='rdbControlRepartidorXSucursal'
                            name="ParControlRepartidorXSucursal"
                            checked={Datos.ParControlRepartidorXSucursal.value}
                            label="Sucursal"
                            value="1"
                            onChange={this.handleControlRepartidor} />
                    </Col>
                    <Col>
                        <RadioButton id='rdbControlRepartidorXCallCenter'
                            name="ParControlRepartidorXSucursal"
                            checked={!Datos.ParControlRepartidorXSucursal.value}
                            label="Call Center"
                            value="2"
                            onChange={this.handleControlRepartidor} />
                    </Col>
                    <Col xs="6">
                        <CheckBox
                            id="ValidarArticuloDespacho"
                            attributes={Datos.ValidarArticuloDespacho.attributes}
                            value={Datos.ValidarArticuloDespacho.value}
                            label={Datos.ValidarArticuloDespacho.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <h6>Movimiento InterBodega</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Select
                            id="Par_Mov_Interbodega"
                            name="Par_Mov_Interbodega"
                            labelText={Datos.Par_Mov_Interbodega.attributes.label}
                            classNameContainer="form-group"
                            className="form-control"
                            value={Datos.Par_Mov_Interbodega.value}
                            onChange={this.onSelectChanged}
                            configuration={{
                                valueField: "Tipo_Id",
                                textField: "Nombre",
                                options: lstTiposMovimientos,
                            }}
                        />
                    </Col>
                    <Col></Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <h6>Colores</h6>
                    </Col>
                </Row>
                <Row>
                    <ColorPicker
                        col={4}
                        label={Datos.ParBackColor_I.attributes.label}
                        classC={Datos.ParBackColor_I.attributes.class}
                        description={Datos.ParBackColor_I.attributes.description}
                        lstColors={lstColoresHexa}
                        handleChange={this.handleChangeColor_I}
                    />

                    <ColorPicker
                        col={4}
                        label={Datos.ParBackColor_M.attributes.label}
                        classC={Datos.ParBackColor_M.attributes.class}
                        description={Datos.ParBackColor_M.attributes.description}
                        lstColors={lstColoresHexa}
                        handleChange={this.handleChangeColor_M}
                    />

                    <ColorPicker
                        col={4}
                        label={Datos.ParBackColor_T.attributes.label}
                        classC={Datos.ParBackColor_T.attributes.class}
                        description={Datos.ParBackColor_T.attributes.description}
                        lstColors={lstColoresHexa}
                        handleChange={this.handleChangeColor_T}
                    />

                    <ColorPicker
                        col={4}
                        label={Datos.ParBackColor_N.attributes.label}
                        classC={Datos.ParBackColor_N.attributes.class}
                        description={Datos.ParBackColor_N.attributes.description}
                        lstColors={lstColoresHexa}
                        handleChange={this.handleChangeColor_N}
                    />

                    <ColorPicker
                        col={4}
                        label={Datos.ParBackColor_E.attributes.label}
                        classC={Datos.ParBackColor_E.attributes.class}
                        description={Datos.ParBackColor_E.attributes.description}
                        lstColors={lstColoresHexa}
                        handleChange={this.handleChangeColor_E}
                    />
                </Row>
                <Row>
                    <Col xs={6}>
                        <h6>Forma de Pago</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CheckBox
                            id="Efectivo"
                            attributes={Datos.Efectivo.attributes}
                            value={Datos.Efectivo.value}
                            label={Datos.Efectivo.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="Tarjeta"
                            attributes={Datos.Tarjeta.attributes}
                            value={Datos.Tarjeta.value}
                            label={Datos.Tarjeta.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="Cupones"
                            attributes={Datos.Cupones.attributes}
                            value={Datos.Cupones.value}
                            label={Datos.Cupones.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="Cheque"
                            attributes={Datos.Cheque.attributes}
                            value={Datos.Cheque.value}
                            label={Datos.Cheque.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="MonedaExtranjera"
                            attributes={Datos.MonedaExtranjera.attributes}
                            value={Datos.MonedaExtranjera.value}
                            label={Datos.MonedaExtranjera.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="Monedero"
                            attributes={Datos.Monedero.attributes}
                            value={Datos.Monedero.value}
                            label={Datos.Monedero.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="GiftCard"
                            attributes={Datos.GiftCard.attributes}
                            value={Datos.GiftCard.value}
                            label={Datos.GiftCard.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="Transferencia"
                            attributes={Datos.Transferencia.attributes}
                            value={Datos.Transferencia.value}
                            label={Datos.Transferencia.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                        <CheckBox
                            id="Otra"
                            attributes={Datos.Otra.attributes}
                            value={Datos.Otra.value}
                            label={Datos.Otra.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <br></br>
                        <h6>Actualizar Geolocalización de Cliente</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTexto
                            id="Email_Alias"
                            type="text"
                            label={Datos.Email_Alias.attributes.label}
                            value={Datos.Email_Alias.value}
                            attributes={Datos.Email_Alias.attributes}
                            onChangeInput={this.onChangeInput}
                        />
                    </Col>
                    <Col>
                        <Select
                            id="Pais_Id"
                            name="Pais_Id"
                            labelText={Datos.Pais_Id.attributes.label}
                            classNameContainer="form-group"
                            className="form-control"
                            value={Datos.Pais_Id.value}
                            onChange={this.onSelectChanged}
                            configuration={{
                                valueField: "Id",
                                textField: "Nombre",
                                options: lstPaises,
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTexto
                            id="Url_Site_Geolocalizacion"
                            type="text"
                            label={Datos.Url_Site_Geolocalizacion.attributes.label}
                            value={Datos.Url_Site_Geolocalizacion.value}
                            attributes={Datos.Url_Site_Geolocalizacion.attributes}
                            onChangeInput={this.onChangeInput}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTexto
                            id="ParAPI_WhatsApp"
                            type="text"
                            label={Datos.ParAPI_WhatsApp.attributes.label}
                            value={Datos.ParAPI_WhatsApp.value}
                            attributes={Datos.ParAPI_WhatsApp.attributes}
                            onChangeInput={this.onChangeInput}
                        />
                    </Col>
                    <Col>
                        <CajaTextoNumero
                            id="ParCodigo_Pais"
                            type="number"
                            label="Código de País:"
                            value={Datos.ParCodigo_Pais.value}
                            attributes={Datos.ParCodigo_Pais.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <h6>Calendarización de Órdenes</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CheckBox
                            id="ParPermiteCalendarizadas"
                            attributes={Datos.ParPermiteCalendarizadas.attributes}
                            value={Datos.ParPermiteCalendarizadas.value}
                            label={Datos.ParPermiteCalendarizadas.attributes.label}
                            onChange={this.handleCheckBox}
                        />
                    </Col>
                    <Col>
                        <CajaTextoNumero
                            id="ParDiasCalendarizadas"
                            type="number"
                            label={Datos.ParDiasCalendarizadas.attributes.label}
                            value={Datos.ParDiasCalendarizadas.value}
                            attributes={Datos.ParDiasCalendarizadas.attributes}
                            onChangeInput={this.onChangeInput}
                            onBlur={this.onChangeEditar}
                            onFocus={this.onChangeEditar}
                            onFormatear={this.onFormatoInt}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col xs={6}>
                        <h6>Azure Notifications APP Repartidor</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CajaTexto
                            id="ParNotificacion_Hub_Ruta"
                            type="text"
                            label={Datos.ParNotificacion_Hub_Ruta.attributes.label}
                            value={Datos.ParNotificacion_Hub_Ruta.value}
                            attributes={Datos.ParNotificacion_Hub_Ruta.attributes}
                            onChangeInput={this.onChangeInput}
                        />
                    </Col>
                    <Col>
                        <CajaTexto
                            id="ParNotificacion_Hub_Conexion"
                            type="text"
                            label={Datos.ParNotificacion_Hub_Conexion.attributes.label}
                            value={Datos.ParNotificacion_Hub_Conexion.value}
                            attributes={Datos.ParNotificacion_Hub_Conexion.attributes}
                            onChangeInput={this.onChangeInput}
                        />
                    </Col>
                </Row>

                <hr />
                <Row className="mb-3">
                    <Col className="text-right">
                        <div className="tooltip2">
                            <span className="tooltiptext2">Cancelar</span>
                            <Button variant="secondary" onClick={this.volverAtras}>
                                Cancelar
                            </Button>
                        </div>
                        &nbsp;
                        <div className="tooltip2">
                            <span className="tooltiptext2">Guardar</span>
                            <Button variant="primary" onClick={this.ingresarDatos}>
                                Guardar
                            </Button>
                        </div>
                    </Col>
                </Row>
                <ModalBusqueda
                    show={selectModal}
                    contentLabel={"selectedBusquedas"}
                    datos={lstClientes}
                    id={"Cliente_Id"}
                    columnas={columnasClientes}
                    striped={false}
                    hover={true}
                    condensed={false}
                    selectRow={selectRow}
                    onDoubleClick={this.onDoubleClick}
                    label={"Lista de Clientes"}
                    cerrarModal={this.cerrarModal}
                    seleccionModal={this.seleccionModal}
                    onClickSearch={this.onClickSearch}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
    };
};

export default connect(mapStateToProps)(withRouter(memo(TabParametros)));
